<template>
  <div>
    <section class="page-content">
      <form action @submit.prevent="next">
        <article class="title-section-quick-quote form-section mb-0">
          <h1 class="page-title text-center">APPLICATION</h1>
          <h2 class="form-title text-center">Insurance Broker/ Agent Errors & Omissions Insurance
            <br /> MGA /Wholesaler/ Manager</h2>
          <h2 class="form-title text-center" style="padding-top: 20px;">NOTICE</h2>
        </article>

        <article class="input-section form-section" >
          <div style="border: 2px solid black;" class="p-2">
            <p class="mt-1 mb-1">
              <strong>NOTICE:</strong> BY COMPLETING THIS APPLICATION YOU ARE APPLYING FOR INSURANCE BROKER/ AGENT ERRORS & OMISSIONS INSURANCE.
            </p>
            <p class="mt-1 mb-1">
              THIS APPLICATION IS FOR CLAIMS MADE AND REPORTED COVERAGE, WHICH APPLIES ONLY TO "CLAIMS" FIRST MADE AND REPORTED IN WRITING DURING THE "POLICY PERIOD," OR ANY EXTENDED REPORTED PERIOD. THE LIMIT OF LIABILITY TO PAY DAMAGES OR SETTLEMENTS WILL BE REDUCED AND MAY BE EXHAUSTED BY "DEFENSE COSTS," AND "DEFENSE COSTS" WILL BE APPLIED AGAINST YOUR DEDUCTIBLE. THE COVERAGE APPLIED FOR WITH THIS APPLICATION DIFFERS IN SOME RESPECTS FROM THAT AFFORDED UNDER OTHER POLICIES. READ THE ENTIRE APPLICATION CAREFULLY BEFORE SIGNING.             </p>
          </div>
        </article>
        <article class="form-heading title-section form-section flex">
          <h1 class="form-title">PART 1: APPLICANT INFORMATION</h1>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">1.</span>Name of Applicant:
          </label>
          <input
            type="text"
            name="nameOfApplicant"
            v-model="mgaApplication.nameOfApplicant"
            class="orep-text-input"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('nameOfApplicant')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('nameOfApplicant') | filterText }}</span>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">2.</span>
            Business Name (DBA):
          </label>
          <input
            type="text"
            name="businessName"
            v-model="mgaApplication.businessName"
            class="orep-text-input"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('businessName')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('businessName') | filterText }}</span>
        </article>
        <article class="form-section">
          <div class="input-section" >
            <div class="row pb-3">
              <div class="col-md-6">
                <label for class="orep-label mb-0 ml-1">
                  <span class="mr-1">3.</span>
                  Street Address
                </label>
                <input
                  type="text"
                  name="address"
                  v-model="mgaApplication.customer.address"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('address')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('address') | filterText }}</span>
              </div>
              <div class="col-md-6">
                <label for class="orep-label mb-0 ml-1">
                  City:
                </label>
                <input
                  type="text"
                  name="city"
                  v-model="mgaApplication.customer.city"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('city')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('city') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-4">
                <label for class="orep-label mb-0 ml-1">
                  State:
                </label>
                <select
                  class="orep-select w-100"
                  style="height: 40px; width: 383px;"
                  name="state"
                  v-model="mgaApplication.customer.state"
                  v-validate="'required'"
                  @change="validateBeforeSubmit()"
                >
                  <option v-for="(item, key) in states" :value="key">
                    {{item}}
                  </option>
                </select>
                <span
                  v-show="errors.has('state')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('state') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0 ml-1">
                  ZIP Code:
                </label>
                <input
                    type="text"
                    name="zipCode"
                    v-model="mgaApplication.customer.zipCode"
                    class="orep-text-input w-100"
                    v-validate="'required|numeric|length:5'"
                    maxlength="5"
                    inputmode="numeric"
                    @keypress="!/^\d$/.test($event.key) ? ($event.preventDefault(), zipCodeError = 'Please enter numeric values only') : (zipCodeError = '')"
                    @input="validateBeforeSubmit()"
                >
                <span v-if="zipCodeError" class="text-danger small">{{ zipCodeError }}</span>
                <span
                  v-show="errors.has('zipCode')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('zipCode') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0 ml-1">
                  Website
                </label>
                <input
                  type="text"
                  name="website"
                  v-model="mgaApplication.website"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('website')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('website') | filterText }}</span>
              </div>
            </div>
          </div>

        </article>

        <article class="form-heading title-section form-section flex">
          <h1 class="form-title">Additional Locations </h1>
        </article>
        <article class="form-section">
          <div class="input-section">
            <div class="row pb-3">
              <div class="col-md-12">
                <div class="radio orep-radio-wrapper solo-checkbox" style="padding-top: 20px">
                  <label class="orep-label ml-1">
                    <input
                        type="checkbox"
                        name="checkIfNoAdditionalLocations"
                        class="orep-radio w-40"
                        v-model="mgaApplication.checkIfNoAdditionalLocations"
                    >
                    <span class="radio-span solo-checkbox-span" style="color: #046085">
                    No Additional Locations
                  </span>
                  </label>
                </div>
              </div>
            </div>
            <div v-if="!mgaApplication.checkIfNoAdditionalLocations" class="row pb-3">
              <div class="col-md-12">
                <label for class="orep-label mb-0 ml-1">
                  <span class="mr-1">1.</span>
                  Street
                </label>
                <input
                    type="text"
                    name="streetOne"
                    v-model="mgaApplication.streetOne"
                    class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                >
              </div>
            </div>
            <div v-if="!mgaApplication.checkIfNoAdditionalLocations" class="row pb-3">
              <div class="col-md-2">
                <label for class="orep-label mb-0 ml-1">
                  City:
                </label>
                <input
                    type="text"
                    name="cityOne"
                    v-model="mgaApplication.cityOne"
                    class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                >
              </div>
              <div class="col-md-2">
                <label for class="orep-label mb-0 ml-1">
                  State:
                </label>
                <select
                    class="orep-select w-100"
                    style="height: 40px; width: 100%;"
                    name="stateOne"
                    v-model="mgaApplication.stateOne"
                    @change="validateBeforeSubmit()"
                >
                  <option v-for="(item, key) in states" :value="key">
                    {{item}}
                  </option>
                </select>
              </div>
              <div class="col-md-2">
                <label for class="orep-label mb-0 ml-1">
                  ZIP Code:
                </label>
                <input
                    type="text"
                    name="zipCodeOne"
                    v-model="mgaApplication.zipCodeOne"
                    class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                >
              </div>
              <div class="col-md-3">
                <label for class="orep-label mb-0">
                  <span class="qtn mrpx-5"></span>Phone:
                </label>
                <input
                    type="text"
                    name="phoneOne"
                    v-model="mgaApplication.phoneOne"
                    class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                >
              </div>
              <div class="col-md-3">
                <label for class="orep-label mb-0">
                  <span class="qtn mrpx-5"></span>Fax:
                </label>
                <input
                    type="text"
                    name="faxOne"
                    v-model="mgaApplication.faxOne"
                    class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                >
              </div>
            </div>
            <div v-if="!mgaApplication.checkIfNoAdditionalLocations" class="row pb-3">
              <div class="col-md-12">
                <label for class="orep-label mb-0 ml-1">
                  <span class="mr-1">2.</span>
                  Street
                </label>
                <input
                    type="text"
                    name="streetTwo"
                    v-model="mgaApplication.streetTwo"
                    class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                >
              </div>
            </div>
            <div v-if="!mgaApplication.checkIfNoAdditionalLocations" class="row pb-3">
              <div class="col-md-2">
                <label for class="orep-label mb-0 ml-1">
                  City:
                </label>
                <input
                    type="text"
                    name="cityTwo"
                    v-model="mgaApplication.cityTwo"
                    class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                >
              </div>
              <div class="col-md-2">
                <label for class="orep-label mb-0 ml-1">
                  State:
                </label>
                <select
                    class="orep-select w-100"
                    style="height: 40px; width: 100%;"
                    name="stateTwo"
                    v-model="mgaApplication.stateTwo"
                    @change="validateBeforeSubmit()"
                >
                  <option v-for="(item, key) in states" :value="key">
                    {{item}}
                  </option>
                </select>
              </div>
              <div class="col-md-2">
                <label for class="orep-label mb-0 ml-1">
                  ZIP Code:
                </label>
                <input
                    type="text"
                    name="zipCodeTwo"
                    v-model="mgaApplication.zipCodeTwo"
                    class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                >
              </div>
              <div class="col-md-3">
                <label for class="orep-label mb-0">
                  <span class="qtn mrpx-5"></span>Phone:
                </label>
                <input
                    type="text"
                    name="phoneTwo"
                    v-model="mgaApplication.phoneTwo"
                    class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                >
              </div>
              <div class="col-md-3">
                <label for class="orep-label mb-0">
                  <span class="qtn mrpx-5"></span>Fax:
                </label>
                <input
                    type="text"
                    name="faxTwo"
                    v-model="mgaApplication.faxTwo"
                    class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                >
              </div>
            </div>
            <div v-if="!mgaApplication.checkIfNoAdditionalLocations" class="row pb-3">
              <div class="col-md-12">
                <label for class="orep-label mb-0 ml-1">
                  <span class="mr-1">3.</span>
                  Street
                </label>
                <input
                    type="text"
                    name="streetThree"
                    v-model="mgaApplication.streetThree"
                    class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                >
              </div>
            </div>
            <div v-if="!mgaApplication.checkIfNoAdditionalLocations" class="row pb-3">
              <div class="col-md-2">
                <label for class="orep-label mb-0 ml-1">
                  City:
                </label>
                <input
                    type="text"
                    name="cityThree"
                    v-model="mgaApplication.cityThree"
                    class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                >
              </div>
              <div class="col-md-2">
                <label for class="orep-label mb-0 ml-1">
                  State:
                </label>
                <select
                    class="orep-select w-100"
                    style="height: 40px; width: 100%;"
                    name="stateThree"
                    v-model="mgaApplication.stateThree"
                    @change="validateBeforeSubmit()"
                >
                  <option v-for="(item, key) in states" :value="key">
                    {{item}}
                  </option>
                </select>
              </div>
              <div class="col-md-2">
                <label for class="orep-label mb-0 ml-1">
                  ZIP Code:
                </label>
                <input
                    type="text"
                    name="zipCodeThree"
                    v-model="mgaApplication.zipCodeThree"
                    class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                >
              </div>
              <div class="col-md-3">
                <label for class="orep-label mb-0">
                  <span class="qtn mrpx-5"></span>Phone:
                </label>
                <input
                    type="text"
                    name="phoneThree"
                    v-model="mgaApplication.phoneThree"
                    class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                >
              </div>
              <div class="col-md-3">
                <label for class="orep-label mb-0">
                  <span class="qtn mrpx-5"></span>Fax:
                </label>
                <input
                    type="text"
                    name="faxThree"
                    v-model="mgaApplication.faxThree"
                    class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                >
              </div>
            </div>
          </div>
        </article>

        <article class="form-section">
          <div class="input-section" >
            <div class="row pb-3">
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="mr-1">4.</span><span class="qtn mrpx-5"></span>Phone:
                </label>
                <input
                    type="text"
                    name="phone"
                    v-model="mgaApplication.customer.phone"
                    class="orep-text-input w-100"
                    v-validate="'required'"
                    @input="validateBeforeSubmit()"
                >
                <span
                    v-show="errors.has('phone')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('phone') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="qtn mrpx-5"></span>Fax:
                </label>
                <input
                    type="text"
                    name="fax"
                    v-model="mgaApplication.customer.fax"
                    class="orep-text-input w-100"
                >
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="mr-1"></span>Email:
                </label>
                <input
                    type="email"
                    name="email"
                    autocomplete="email"
                    v-model="mgaApplication.customer.email"
                    class="orep-text-input w-100"
                    v-validate="'required|email'"
                    @input="validateBeforeSubmit()"
                >
                <span
                    v-show="errors.has('email')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('email') | filterText }}</span>
              </div>

            </div>
          </div>

        </article>

        <article class="input-section form-section">
          <div class="row align-items-center mx-1 pb-0 pt-3">
            <label for class="orep-label">
              <span class="mr-1">6.</span>Applicant is: </label>
            <div class="radio orep-radio-wrapper w-100">
              <label>
                <input
                  type="radio"
                  name="individual"
                  value="individual"
                  class="orep-radio"
                  v-validate="'required|included:individual,partnership,corporation,llc'"
                  @change="validateBeforeSubmit()"
                  v-model="mgaApplication.applicantOwnership"
                >
                <span class="radio-span">Individual</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper w-100">
              <label>
                <input
                  type="radio"
                  name="partnership"
                  value="partnership"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="mgaApplication.applicantOwnership"
                >
                <span class="radio-span">Partnership</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper w-100">
              <label>
                <input
                  type="radio"
                  name="corporation"
                  value="corporation"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="mgaApplication.applicantOwnership"
                >
                <span class="radio-span">Corporation</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper w-100">
              <label>
                <input
                  type="radio"
                  name="llc"
                  value="llc"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="mgaApplication.applicantOwnership"
                >
                <span class="radio-span">LLC</span>
              </label>
            </div>
            <span
              v-show="errors.has('individual')"
              class="help is-danger form-errors text-danger mt-0 mb-2"
            >{{ errors.first('individual') | filterText }}</span>
          </div>
        </article>

        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="mr-1">7.</span>Date Agency Established:
          </label>
          <input
              type="text"
              name="dateAgencyEstablished"
              v-model="mgaApplication.dateAgencyEstablished"
              class="orep-text-input"
              v-validate="'required'"
              @input="validateBeforeSubmit()"
          >
          <span
              v-show="errors.has('dateAgencyEstablished')"
              class="help is-danger form-errors text-danger"
          >{{ errors.first('dateAgencyEstablished') | filterText }}</span>
        </article>
        <article class="input-section form-section">
          <div class="row pb-3">
            <div class="col-md-auto">
              <label for class="orep-label">
                <span class="mr-1">8.</span>Ownership Name
              </label>
              <input
                  type="text"
                  id="ownershipNameOne"
                  name="ownershipNameOne"
                  v-model="mgaApplication.ownershipNameOne"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
              >
              <span
                  v-show="errors.has('ownershipNameOne')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('ownershipNameOne') | filterText }}</span>
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <label for class="orep-label">
                Ownership %
              </label>
              <input
                  type="text"
                  id="ownershipOne"
                  name="ownershipOne"
                  v-model="mgaApplication.ownershipOne"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
              >
              <span
                  v-show="errors.has('ownershipOne')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('ownershipOne') | filterText }}</span>
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <label for class="orep-label">
                Active
              </label>
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownershipActiveOne"
                        id="ownershipActiveYes"
                        value="true"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.ownershipActiveOne"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownershipActiveOne"
                        id="ownershipActiveNo"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-validate="'required'"
                        v-model="mgaApplication.ownershipActiveOne"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                  v-show="errors.has('ownershipActiveOne')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('ownershipActiveOne') | filterText }}</span>
            </div>
            <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <label for class="orep-label">
                Title
              </label>
              <input
                  type="text"
                  id="ownershipTitleOne"
                  name="ownershipTitleOne"
                  v-model="mgaApplication.ownershipTitleOne"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
              >
              <span
                  v-show="errors.has('ownershipTitleOne')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('ownershipTitleOne') | filterText }}</span>
            </div>
            <div class="col-md-2">
              <label for class="orep-label">
                Experience
              </label>
              <input
                  type="text"
                  id="ownershipExperienceOne"
                  name="ownershipExperienceOne"
                  v-model="mgaApplication.ownershipExperienceOne"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
              >
              <span
                  v-show="errors.has('ownershipExperienceOne')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('ownershipExperienceOne') | filterText }}</span>
            </div>
          </div>
          <!-- Section 2 -->
          <div class="row pb-3">
            <div class="col-md-auto">
              <input
                  type="text"
                  id="ownershipNameTwo"
                  name="ownershipNameTwo"
                  v-model="mgaApplication.ownershipNameTwo"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2">
              <input
                  type="text"
                  id="ownershipTwo"
                  name="ownershipTwo"
                  v-model="mgaApplication.ownershipTwo"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownershipActiveTwo"
                        id="ownershipActiveYes"
                        value="true"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.ownershipActiveTwo"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownershipActiveTwo"
                        id="ownershipActiveNo"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.ownershipActiveTwo"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="ownershipTitleTwo"
                  name="ownershipTitleTwo"
                  v-model="mgaApplication.ownershipTitleTwo"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="ownershipExperienceTwo"
                  name="ownershipExperienceTwo"
                  v-model="mgaApplication.ownershipExperienceTwo"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
          </div>

          <!-- Section 3 -->
          <div class="row pb-3">
            <div class="col-md-auto">
              <input
                  type="text"
                  id="ownershipNameThree"
                  name="ownershipNameThree"
                  v-model="mgaApplication.ownershipNameThree"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="ownershipThree"
                  name="ownershipThree"
                  v-model="mgaApplication.ownershipThree"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownershipActiveThree"
                        id="ownershipActiveYes"
                        value="true"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.ownershipActiveThree"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                        type="radio"
                        name="ownershipActiveThree"
                        id="ownershipActiveNo"
                        value="false"
                        class="orep-radio"
                        @change="validateBeforeSubmit()"
                        v-model="mgaApplication.ownershipActiveThree"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="ownershipTitleThree"
                  name="ownershipTitleThree"
                  v-model="mgaApplication.ownershipTitleThree"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
            <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
              <input
                  type="text"
                  id="ownershipExperienceThree"
                  name="ownershipExperienceThree"
                  v-model="mgaApplication.ownershipExperienceThree"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
              >
            </div>
          </div>
        </article>
      </form>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <article class="orep-pagination">
              <button class="pagination-dots pagination-current"></button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ibdpro-mga-application-2')"
                :disabled="!state.pageOneIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ibdpro-mga-application-3')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ibdpro-mga-application-4')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ibdpro-mga-application-5')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid">
              </button>
              <button
                  class="pagination-dots"
                  @click="navigateToNext('ibdpro-mga-application-6')"
                  :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid">
              </button>
              <button
                  class="pagination-dots"
                  @click="navigateToNext('ibdpro-mga-application-7')"
                  :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid || !state.pageSixIsValid">
              </button>
            </article>
            <button type="submit" :disabled="!state.pageOneIsValid"
              :class="{submitDisabled: !state.pageOneIsValid}" class="next-btn mont spaced pull-right" @click="pageOneSubmit('ibdpro-mga-application-2')">Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import {APP_STATUS, STATES} from "../../utils/constants";

export default {
  name: "ibdpro-mga-application-1",
  data() {
    return {
      states: STATES
    };
  },
  computed: {
    mgaApplication() {
      return this.$store.state.mgaApplication.mgaApplication;
    },
    state() {
      return this.$store.state.mgaApplication;
    },
    errorMsg() {
      return this.$store.state.mgaApplication.errorMsg;
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/ibdpro-mga-application-amba/' || this.mgaApplication.customer.partnerName === 'Mercer'){
        return 'Mercer';
      }else if (first === '/portal/ibdpro-mga-application-realshield/' || this.mgaApplication.customer.partnerName === 'Realshield'){
        return 'Realshield';
      }else {
        return 'OREP';
      }
    },
  },

  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },

  methods: {
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    pageOneSubmit(routeName) {
      this.loading = true;
      this.mgaApplication.customer.contactName = this.state.mgaApplication.nameOfPrimaryLicensed;
      this.mgaApplication.customer.companyName = this.state.mgaApplication.nameOfApplicant;
      this.mgaApplication.customer.isMgaApplication = 'True';
      this.mgaApplication.customer.appStatus = APP_STATUS.Partially_Completed;
      if (this.getApplicantType === 'Mercer'){
        this.mgaApplication.customer.partnerName = 'Mercer';
      }
      else if (this.getApplicantType === 'Realshield'){
        this.mgaApplication.customer.partnerName = 'Realshield';
      }
      this.mgaApplication.customer.partnerName = 'IBD';
      this.$store.dispatch('mgaApplication/createCustomer');

      // this.$router.push({
      //   name: routeName,
      // });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    }
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    const params = this.$route.query;
    if (params && params.filter) {
      this.state.mgaApplication.applicantRequestFrom = params.filter;
    }
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },
};
</script>

<style scoped>

</style>
